import React from 'react'
import Value from '../Value'
import Rows from '../Rows'
import Description from '../Description'
import Buttons from './Buttons'

export default (props) => (
  <>
    <Description heading='One-Time Costs'>
      Enter the estimated one-time expenses in the fields below that you anticipate you'll be paying for. You can include (and remove) categories easily by clicking the checkbox next to each item. All pre-populated expense amounts are based on average costs of each item. Click back to return to the monthly expenses and next to continue to your results.
    </Description>
    <Rows baseName='oneTimeCosts' {...props}>
      {({ label, ...rest }) => (
        <>
          {label}
          <Value {...rest} />
        </>
      )}
    </Rows>
    <Buttons {...props} />
  </>
)
